module.exports = __webpack_public_path__ + "static/media/Foster.09dc805e.png";